import { render, staticRenderFns } from "./studyExp.vue?vue&type=template&id=1ab2574a&scoped=true&"
import script from "./studyExp.vue?vue&type=script&lang=js&"
export * from "./studyExp.vue?vue&type=script&lang=js&"
import style0 from "./studyExp.vue?vue&type=style&index=0&id=1ab2574a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2574a",
  null
  
)

export default component.exports